export const ETolgeeDefault = {
  COMMON_ATTENTION: 'attention',
  COMMON_NO: 'common.no',
  COMMON_YES: 'common.yes',
  COMMON_LOADING: 'common.loading',
  COMMON_OBSOLETE: 'common.obsolete',
  COMMON_ACTIVE: 'common.active',
  COMMON_ACTION_ACTIONS: 'common.actions.actions',
  COMMON_ACTION_ACTIONS_SUCCESS: 'common.actions.success',
  COMMON_ACTION_ACTIONS_ERROR: 'common.actions.error',
  COMMON_ACTION_BACK: 'common.actions.back',
  COMMON_ACTION_SEARCH: 'common.actions.search',
  COMMON_ACTION_SEARCHING: 'common.actions.searching',
  COMMON_ACTION_SAVE: 'common.actions.save',
  COMMON_ACTION_SAVING: 'common.actions.saving',
  COMMON_ACTION_UPDATING: 'common.actions.updating',
  COMMON_ACTION_DELETE: 'common.actions.delete',
  COMMON_ACTION_DELETING: 'common.actions.deleting',
  COMMON_ACTION_CANCEL: 'common.actions.cancel',
  COMMON_ACTION_CREATE_CAMPAIGN: 'common.actions.createCampaign',
  COMMON_TEXT_SELECT_DATES: 'common.text.selectDates',
  COMMON_ACTION_CANCELING: 'common.actions.canceling',
  COMMON_ACTION_CREATE: 'common.actions.create',
  COMMON_ACTION_CREATING: 'common.actions.creating',
  COMMON_ACTION_VIEW: 'common.actions.view',
  COMMON_ACTION_VIEWING: 'common.actions.viewing',
  COMMON_ACTION_EDIT: 'common.actions.edit',
  COMMON_ACTION_EDITING: 'common.actions.editing',
  COMMON_ACTION_CLOSE: 'common.actions.close',
  COMMON_ACTION_CLEAR_FILTERS: 'common.actions.clearFilters',
  ENUM_OPERATION_TYPES_ADHESION: 'enum.operationTypes.adhesion',
  ENUM_OPERATION_TYPES_SIMPLE_CHANGE: 'enum.operationTypes.simpleChange',
  ENUM_OPERATION_TYPES_COMPLETE_CHANGE: 'enum.operationTypes.completeChange',
  ENUM_OPERATION_TYPES_SUSPENSION: 'enum.operationTypes.suspension',
  ENUM_OPERATION_TYPES_REACTIVATION: 'enum.operationTypes.reactivation',
  ENUM_CALENDAR_STATUS_DRAFT: 'enum.calendarStatus.draft',
  ENUM_CALENDAR_STATUS_OPEN: 'enum.calendarStatus.open',
  ENUM_CALENDAR_STATUS_CLOSED: 'enum.calendarStatus.closed',
  ENUM_CALENDAR_STATUS_PROCESSING: 'enum.calendarStatus.processing',
  ENUM_CALENDAR_STATUS_PENDING: 'enum.calendarStatus.pending',
  ENUM_CALENDAR_STATUS_CONCLUDED: 'enum.calendarStatus.concluded',
  ENUM_CALENDAR_STATUS_SOLICITATIONS: 'enum.calendarStatus.solicitations',
  ENUM_MONTHS_JANUARY: 'enum.months.january',
  ENUM_MONTHS_FEBRUARY: 'enum.months.february',
  ENUM_MONTHS_MARCH: 'enum.months.march',
  ENUM_MONTHS_APRIL: 'enum.months.april',
  ENUM_MONTHS_MAY: 'enum.months.may',
  ENUM_MONTHS_JUNE: 'enum.months.june',
  ENUM_MONTHS_JULY: 'enum.months.july',
  ENUM_MONTHS_AUGUST: 'enum.months.august',
  ENUM_MONTHS_SEPTEMBER: 'enum.months.september',
  ENUM_MONTHS_OCTOBER: 'enum.months.october',
  ENUM_MONTHS_NOVEMBER: 'enum.months.november',
  ENUM_MONTHS_DECEMBER: 'enum.months.december',
  ENUM_REQUEST_STATUS_PENDING: 'enum.requestStatus.pending',
  ENUM_REQUEST_STATUS_FAILED: 'enum.requestStatus.failed',
  ENUM_REQUEST_STATUS_PROCESSED: 'enum.requestStatus.processed',
  ENUM_REQUEST_STATUS_APPROVED: 'enum.requestStatus.approved',
  ENUM_REQUEST_STATUS_REJECTED: 'enum.requestStatus.rejected',
  ENUM_REQUEST_STATUS_QUEUED: 'enum.requestStatus.queued',
  ENUM_REQUEST_STATUS_SUCCESS: 'enum.requestStatus.success',
  ENUM_REQUEST_STATUS_SOLICITATION: 'enum.requestStatus.solicitations',
  ENUM_REQUEST_STATUS_PROCESSING: 'enum.requestStatus.processing',
  ENUM_REQUEST_STATUS_COMPLETED: 'enum.requestStatus.completed',
  ENUM_EMPLOYEE_STATUS_NOT_CONTRACTED: 'enum.employeeStatus.notContracted',
  ENUM_EMPLOYEE_STATUS_DRAFT: 'enum.employeeStatus.draft',
  ENUM_EMPLOYEE_STATUS_SUBMITTED: 'enum.employeeStatus.submitted',
  ENUM_EMPLOYEE_STATUS_APPROVED: 'enum.employeeStatus.approved',
  ENUM_EMPLOYEE_STATUS_SUSPENDED: 'enum.employeeStatus.suspended',
  ENUM_ORIGIN_SOURCE_PORTAL: 'enum.originSource.portal',
  ENUM_ORIGIN_SOURCE_APP: 'enum.originSource.app',
  ENUM_ORIGIN_SOURCE_HR: 'enum.originSource.hr',
  ENUM_ORIGIN_SOURCE_INTEGRATION: 'enum.originSource.integration',
  ENUM_ORIGIN_SOURCE_ADMIN: 'enum.originSource.admin',
  ENUM_ORIGIN_SOURCE_USER: 'enum.originSource.user',
  ENUM_REQUEST_STATUS_CANCELED: 'enum.requestStatus.canceled',
  SHARED_COMPONENTS_CONFIRMATION_MODAL_DESCRIPTION:
    'shared.components.confirmationModal.description',
  COMMON_CHANGE: 'common.change',
  COMMON_ACTION_EXPORT: 'common.actions.export',
  COMMON_ACTION_ACTIONS_INFO: 'common.actions.info',
  COMMON_ALERT: 'common.alert',
  COMMON_NOT_INFORMED: 'common.notInformed',
  COMMON_NOT_LISTED: 'common.notListed',
  COMMON_STATUS: 'common.status',
  COMMON_NOT_ACQUIRED: 'common.notAcquired',
  BLOCKED_TITLE: 'blocked.title',
  BLOCKED_SUBTITLE: 'blocked.subtitle',
  COMMON_REASON: 'common.reason'
} as const;

export type ETolgeeDefault =
  (typeof ETolgeeDefault)[keyof typeof ETolgeeDefault];
